import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import Pricecalculator from '../../Components/pricecalculator';
import BuyButton from '../../Components/BuyButton';
import ProductTierPriceContainer from './ProductTierPriceContainer';
import ShoppingListButton from '../ShoppingListButton';
import Triangle from '../Triangle';
import Circle from '../Circle';
import Square from '../Square';
import ProductChainIcon from './ProductChainIcon';
import StoreList from '../StoreList';
import Popup from '../Popup';
import { getClickCollectOrgs } from '../../Actions/GetClickCollectOrgs.action';
import { googleAnalytics } from '../../Services/googleAnalytics';
import { updatePreferredClickCollectAddress } from '../../Actions/PreferredClickCollectAddress.action';

const GridViewModelContainer = (props) => {
  const dispatch = useDispatch();
  const [titles, setTitleValue] = useState(
    props.excludeparsing == false ? JSON.parse(props.heading) : props.heading
  );
  const [products, setProducts] = useState(
    props.excludeparsing == false ? JSON.parse(props.products) : props.products
  );
  const [isChassiSearch, setIsChassiSearch] = useState(
    props.isChassiSearch ? props.isChassiSearch : false
  );

  const [isOpenStoreList, setOpenStoreList] = useState(false);
  const isrecommendedprice = useSelector((state) => state.recommendedprice.isrecommendedprice);
  const stores = useSelector((state) => state.clickCollectOrgs);
  const [store, setStore] = useState(null)
  const [reRender, setReRender] = useState(true)
  const hideShoppingList = window.__litium.constants.hideShoppingList;
  const showBuyButtons = window.__litium.constants.showBuyButtons;
  const { hidePrices} = window.__litium.channelConfig;

  useEffect(() => {
    let preffStore = JSON.parse(window.localStorage.getItem("preferedaddress"));
    let clickStore = JSON.parse(window.localStorage.getItem("preferredclickcollectaddress"));
    
    if(store == null && preffStore && preffStore.productAssortment?.includes("active")&& reRender){

        let streetAddress = preffStore.streetName;
        streetAddress += preffStore.zipCode ? " " + preffStore.zipCode : "";
        streetAddress += preffStore.city ? " " + preffStore.city : "";

        let store = {
          organizationId: preffStore.organizationId,
          organizationName: preffStore.companyName,
          email: preffStore.email,
          homePage: preffStore.homePage,
          address: streetAddress,
          productAssortment: preffStore.productAssortment,
          shopName: preffStore.name,
          latitude: preffStore.latitude,
          longitude: preffStore.longitude
        }
        setStore(store)
        setReRender(false)
        //window.localStorage.removeItem('preferredclickcollectaddress');
        dispatch(updatePreferredClickCollectAddress(store));
      
    }
    else if(clickStore){
      setStore(clickStore);
    }

  },[isOpenStoreList])

  const renderProductSpec = (product) => {
    
    return (
      <div className="product__specification specification-wrap">
        <table className="product-table defaulttable">
          <tbody>
            <tr className="product__specification--list">
              <td className="name">{translate('product.shortenedarticlenumber')}</td>
              <td className="value">
                  {product.Id}
                  {product.HasChildOrIsChild == true && (
                    <ProductChainIcon product={product} />
                  )}
              </td>
            </tr>
            {product.SpecificationForProductPage &&
              product.SpecificationForProductPage.map(
                (specification, sindex) => {
                  if(!specification.IsArticleNumber) {
                    return (
                    <tr
                    className="product__specification--list"
                    key={'tr' + sindex}
                  >
                    <td className="name">
                      {specification.Name}
                      {specification.Description && (
                        <span className="product-tooltip">
                          ?{' '}
                          <span
                            data-tip={specification.Description}
                            className="product-tooltip--content"
                          ></span>{' '}
                        </span>
                      )}

                    </td>
                    <td className="value">
                      {specification.Value}
                      {product.HasChildOrIsChild == true && specification.IsArticleNumber == true && (
                        <ProductChainIcon product={product} />
                      )}
                      </td>
                  </tr>
                    )
                    
                  } else {
                    return null;
                  }
                  
                }
              )}
              {isChassiSearch == true && (
              <tr>
                <td>{translate('product.articlenumber')}</td>
                <td className="value">
                  {product.Id}
                  {product.HasChildOrIsChild == true && (
                    <ProductChainIcon product={product} />
                  )}
                </td>
              </tr>
            )}
            {product.StockStatus && (
              <tr className="product__specification--list">
                <td className="name">{translate('common.stock')}</td>
                <td className="value">
                  {product.StockStatus == 'triangle' && <Triangle></Triangle>}
                  {product.StockStatus == 'circle' && <Circle></Circle>}
                  {product.StockStatus == 'square' && (
                    <Square quantity={product.QuantityInStock}></Square>
                  )}
                </td>
              </tr>
            )}
            {!hidePrices && (
              <tr className={'product__specification--actions'}>
                <td className="name">
                  {translate(
                    isrecommendedprice ? 'product.rekpris' : 'product.netprice'
                  )}
                  {product.CampaignPrice && !isrecommendedprice && <div>&nbsp;</div>}
                </td>

                <td className={`value price`}>
                  <Pricecalculator
                    isauthorized={props.authenticated?.toString()?.toLowerCase() === 'true'}
                    //table component does not rerender when switching vat/nonvat unless we use this
                    netpricincludingvat={product.NetPriceIncludingVAT}
                    netpriceexcludingvat={product.NetPrice}
                    recommendedpriceexcludingvat={product.RecommendedPrice}
                    recommendedpriceincludingvat={product.RecommendedPriceIncludingVAT}
                    campaignpriceincludingvat={product.CampaignPriceIncludingVAT}
                    campaignprice={product.CampaignPrice}
                  />
                </td>
              </tr>
            )}
          </tbody>
          
        </table>
      </div>
    );
  };

  const renderProduct = (product, index) => {
    const dispatch = useDispatch();

    const handleOpenPopup = (productId) => {
      setOpenStoreList(true);
      dispatch(getClickCollectOrgs(productId))
    }

    return (
            <div key={'li' + index}
              itemScope
              itemType="http://schema.org/Product"
              className={
                product.IsExpired
                  ? 'product__wrapper product--expired'
                  : 'product__wrapper'
              }
            >
              <figure className="product__figure">
                {product.PLCBanner && (
                  <span
                    className="plc-status"
                    style={{ backgroundColor: product.PLCBanner.ColorCode }}
                  >
                    {product.PLCBanner.Text}
                  </span>
                )}
                <a href={product.Url} title={product.Name} tabIndex={-1}>
                  <div
                    className="product__figure--img"
                    dangerouslySetInnerHTML={{ __html: product.ImageUrl }}
                  ></div>
                </a>
              </figure>
              <article className="product__info">
                <meta itemProp="description" content={product.Description} />
                <a
                  href={product.Url}
                  className="product__name--link"
                >
                  <h2 itemProp="name" className="product__name">
                    {product.Name}
                    <svg>
                      <use href="/ui/images/sprites/brenderup.svg#right-arrow"></use>
                    </svg>
                  </h2>
                </a>
                {product.ShouldShowStockStatus && props.isClickAndCollect && (
                  product.IsInStock ? (
                    <div>
                      <span className="product__stock-info" >{translate('product.isinstock')} </span>
                      <a 
                        className="product__stock-info" 
                        title={product.Name} 
                        tabIndex={0}
                        onClick={() => {
                          googleAnalytics({ event: 'clickAndCollectOpenStoreSelect' });
                          handleOpenPopup(product.Id);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              googleAnalytics({ event: 'clickAndCollectOpenStoreSelect' });
                              handleOpenPopup(product.Id);
                            }
                        }}
                      
                      >
                        <span className="product__stock-info--textcolor">{translate('product.showstores')}</span>
                      </a>
                    </div>
                  ) : (
                    <span className="product__stock-info">{translate('product.isnotinstock')}</span>
                  )
                )}
                <div
                  className="product__price"
                  itemProp="offers"
                  itemScope
                  itemType="http://schema.org/Offer"
                >
                  {!props.isClickAndCollect && product.IsInStock ? (
                    <link
                      itemProp="availability"
                      href="http://schema.org/InStock"
                    />
                  ) : (
                    <link
                      itemProp="availability"
                      href="http://schema.org/OutOfStock"
                    />
                  )}
                  <link itemProp="url" href={product.Url} />
                </div>
                {props.hidedescription == false && <div className='product__description-grid'>{product.Description}</div>}
                {renderProductSpec(product)}
                {!hidePrices && !product.IsExpired && product.Price &&
                  product.Price.TierPrices &&
                  product.Price.TierPrices.length > 1 && (
                    <div className="grid-tier-price">
                      <ProductTierPriceContainer
                        product={JSON.stringify(product)}
                      />
                    </div>
                  )}

                <div className="product__buy">
                  {product.IsExpired && (
                    <span className="product__buy-text">
                      {translate(
                        product.ReplacementStatus == 'Never'
                          ? 'replacementProductLabel'
                          : 'similiarProductLabel'
                      )}{' '}
                      <a href={product.AlternativeURL}>
                        {product.AlternativeId}
                      </a>
                    </span>
                  )}

                  {!product.IsExpired && (
                    <div className="row">
                      <div className={`columns product__buy--area ${props.isClickAndCollect ? 'easyline__buy--area' : ''}`}>
                        {showBuyButtons && (
                          <BuyButton
                            articleNumber={product.Id}
                            minValue={product.Price_Multiple}
                            cssClass={
                              product.EnableBuyButton
                                ? 'button buy-button product__buy-button'
                                : 'button buy-button product__buy-button disabled'
                            }
                            label={translate('button.addtocart')}
                            quantityFieldId=""
                          >
                            <span>
                              <a className='button buy-button product__buy-button'>
                                {translate('button.addtocart')}
                              </a>
                            </span>
                          </BuyButton>
                        )}
                        {props.isClickAndCollect && (
                          <BuyButton
                            articleNumber={product.Id}
                            minValue={product.Price_Multiple}
                            cssClass={
                              product.EnableBuyButton
                                ? 'button buy-button product__buy-button easyline__button'
                                : 'button buy-button product__buy-button easyline_button disabled'
                            }
                            label={translate('button.addtocart')}
                            quantityFieldId=""
                          >
                            <span className='easyline__span'>
                              <a className='button buy-button product__buy-button easyline__buy-button'>
                                {translate('button.addtocart')}
                              </a>
                            </span>
                          </BuyButton>
                        )}

                        {!hideShoppingList && (
                          <div className="no-padding shoppinglist-button">
                            <ShoppingListButton
                              productId={product.Id}
                              isSmall={(props.isClickAndCollect || showBuyButtons)}
                              product={product}
                            ></ShoppingListButton>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </article>
            </div>);
  };
  return (
    <Fragment>
      <div className="product-wrap--outer storeList-outer">
        <Popup
          isOpen={isOpenStoreList}
          setOpen={setOpenStoreList}
          component={<StoreList store={store} setStore={setStore} stores={stores.organizations} closeModal={() => setOpenStoreList(false)}></StoreList>}
        ></Popup>
        <div className="">
          <ul className="row product-lists">
            {products &&
                products.map((product, index) => {
                    return <li className="product-list__item columns small-12 small-plus medium-4 large-3" key={'grv-chassi-frg-main' + index}>
                              {renderProduct(product, index)}
                          </li>
            })}
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

export default GridViewModelContainer;
